import type { LeadType, ObjectType, UserType } from '@econtractor/types';
import type {
    BoardFilterLeadSnapshot,
    BoardFilterObjectSnapshot,
    BoardFilterUserSnapshot,
} from '../../helpers/boardFiltersStorage';

export const snapshotToUser = (
    snap: BoardFilterUserSnapshot | null | undefined,
): UserType | null => {
    if (!snap?.ID) return null;
    return {
        ID: snap.ID,
        userName: snap.userName || '',
        userEmail: snap.userEmail || '',
        userPicture: snap.userPicture || '',
    } as UserType;
};

export const snapshotToLead = (
    snap: BoardFilterLeadSnapshot | null | undefined,
): LeadType | null => {
    if (!snap?.ID) return null;
    return {
        ID: snap.ID,
        clientName: snap.clientName || '',
        clientPhone: snap.clientPhone || '',
        clientEmail: snap.clientEmail || '',
        leadStatus: snap.leadStatus || 0,
    } as LeadType;
};

export const snapshotToObject = (
    snap: BoardFilterObjectSnapshot | null | undefined,
): ObjectType | null => {
    if (!snap?.ID) return null;
    return {
        ID: snap.ID,
        objectName: snap.objectName || '',
        clientName: snap.clientName || '',
        teamName: snap.teamName || '',
    } as ObjectType;
};
